export function formatCurrency(value: number) {
  return value != null ? new Intl.NumberFormat('en-NZ', { style: 'currency', currency: 'NZD' }).format(value) : '';
}

export function formatPercentage(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  const str = String(value).trim();

  // Allow a simple numeric format: optional leading sign, digits, optional decimal part
  const numericRe = /^-?\d+(\.\d+)?$/;
  if (!numericRe.test(str)) {
    // Non-numeric display string (e.g. "N/A", "TBD", "12.3%") — return as-is
    return str;
  }

  const num = Number(str);
  if (!isFinite(num)) {
    return str;
  }

  // Your current behaviour divides by 100 (input like 12.34 -> 12.34%)
  return new Intl.NumberFormat('en-NZ', {
    style: 'percent',
    maximumFractionDigits: 2,
  }).format(num / 100);
}

